import { render, staticRenderFns } from "./AppMetrics.vue?vue&type=template&id=4f4055ea"
import script from "./AppMetrics.vue?vue&type=script&lang=js"
export * from "./AppMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports